// @flow

import * as React from 'react';
import Chip from 'app/common/chip';

export function getDwellingStatus(dwelling, user) {
  return dwelling.active === true
    ? user &&
      user.type === 'BUSINESS' &&
      user.verified === true &&
      dwelling.status === 'PENDING_REVIEW'
      ? 'APPROVED'
      : dwelling.status
    : 'DEACTIVATED';
}

const StatusChip = ({ dwelling, user, template }) => {
  return (
    <Chip
      template={(template || getDwellingStatus(dwelling, user)).toLowerCase()}
    />
  );
};

export default StatusChip;
